import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'
import { AgGridReact } from "ag-grid-react";

export const itemColdefs = [
    {
        field: "drawingNo",
        headerName: "Drawing no",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
    {
        field: "itemType",
        headerName: "Item Type",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "itemName",
        headerName: "Item Details",
        minWidth: window.innerWidth * 0.2,
        flex: 1.5,
        filter: true,
    },
    {
        field: "quantity",
        headerName: "Quantity",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "rate",
        headerName: "Rate",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "amount",
        headerName: "Amount",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "discount",
        headerName: "Discount(%)",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "extraCharges",
        headerName: "Extra charges",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "total",
        headerName: "Taxable Amt",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "sgst",
        headerName: "SGST",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "sgstAmt",
        headerName: "SGST Amt",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "cgst",
        headerName: "CGST",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "cgstAmt",
        headerName: "CGST Amt",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "igst",
        headerName: "IGST",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "igstAmt",
        headerName: "IGST Amt",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "netTotal",
        headerName: "Net total",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "remarks",
        headerName: "Remarks",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
];

export const WoOrderReceivePopup = (props) => {
    return (
        <ModalBasic
            id="gatepass"
            classParams="!w-[85%] overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Work order details</span>
                <div className='item-grp grid grid-cols-6 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                    <div className='input-grp'>
                        <label>Work order no</label>
                        <TextInput type='text'
                            id='woRecvNo' name='woRecvNo'
                            value={props.workObject.woRecvNo}
                            handleChange={(event) => props.handleChangeForWork(event, 'woRecvNo')}
                            className={props.validState?.error?.woRecvNo !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Date</label>
                        <TextInput type='date'
                            id='woRecvDate' name='woRecvDate'
                            value={props.workObject.woRecvDate}
                            handleChange={(event) => props.handleChangeForWork(event, 'woRecvDate')}
                            className={props.validState?.error?.woRecvDate !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Select category</label>
                        <MultiSelectDropdown
                            drpIdentity="Select category"
                            options={props.workObject.categoryList}
                            value={props.workObject.idCategory ? props.workObject.categoryList.find(x => x.value === props.workObject.idCategory) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idCategory")
                            }
                            className={props.validState?.error?.idCategory !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-grp'>
                        <label>W.O. type</label>
                        <MultiSelectDropdown
                            drpIdentity="Select WO type"
                            options={props.workObject.woTypeList}
                            value={props.workObject.idWoType ? props.workObject.woTypeList.find(x => x.value === props.workObject.idWoType) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idWoType")
                            }
                            className={props.validState?.error?.idWoType !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-grp'>
                        <label>Delivery date</label>
                        <TextInput type='date'
                            id='deliveryDate' name='deliveryDate'
                            value={props.workObject.deliveryDate}
                            handleChange={(event) => props.handleChangeForWork(event, 'deliveryDate')}
                            className={props.validState?.error?.deliveryDate !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Select customer</label>
                        <MultiSelectDropdown
                            drpIdentity="Select customer"
                            options={props.workObject.customerList}
                            value={props.workObject.idPartyAccount ? props.workObject.customerList.find(x => x.value === props.workObject.idPartyAccount) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idPartyAccount")
                            }
                            className={props.validState?.error?.idPartyAccount !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Select delivery</label>
                        <MultiSelectDropdown
                            drpIdentity="Select delivery"
                            options={props.workObject.deliveryList}
                            value={props.workObject.idDelivery ? props.workObject.deliveryList.find(x => x.value === props.workObject.idDelivery) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idDelivery")
                            }
                            className={props.validState?.error?.idDelivery !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-grp'>
                        <label>Person name</label>
                        <TextInput type='text'
                            id='personName' name='personName'
                            value={props.workObject.personName}
                            handleChange={(event) => props.handleChangeForWork(event, 'personName')}
                            className={props.validState?.error?.personName !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>W.O. priority</label>
                        <MultiSelectDropdown
                            drpIdentity="Select priority"
                            options={props.workObject.WoPrioratyList}
                            value={props.workObject.idWoPrioraty ? props.workObject.WoPrioratyList.find(x => x.value === props.workObject.idWoPrioraty) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idWoPrioraty")
                            }
                            className={props.validState?.error?.idWoPrioraty !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-outer grid grid-cols-6 gap-2.5 col-span-6'>
                        <div className='input-grp row-span-2 col-span-2'>
                            <label>Address</label>
                            <textarea rows={4}
                                id='address' name='address'
                                value={props.workObject.address}
                                onChange={(event) => props.handleChangeForWork(event, 'address')}
                                className={`h-full ${props.validState?.error?.address !== undefined ? "error" : ""}`}
                            />
                        </div>
                        <div className='input-grp row-span-2 col-span-2'>
                            <label>Delivery address</label>
                            <textarea rows={4}
                                id='delAdress' name='delAdress'
                                value={props.workObject.delAdress}
                                onChange={(event) => props.handleChangeForWork(event, 'delAdress')}
                                className={`h-full ${props.validState?.error?.delAdress !== undefined ? "error" : ""}`}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Auth. employee</label>
                            {/* <MultiSelectDropdown
                                drpIdentity="Select employee"
                                options={props.usp_Users}
                                value={props.globalUserID ? props.usp_Users.find(x => x.globalUserID === props.globalUserID) : ''}
                                // onChange={(event) =>
                                //     props.handleChangeForDropdown(event, "idEmployee")
                                // }
                                // className={props.validState?.error?.idEmployee !== undefined ? "error" : ""}
                            /> */}
                            <TextInput type='text'
                                id='usp_Users' name='usp_Users'
                                value={props.usp_Users.find(x => x.globalUserID === props.globalUserID)?.userName || ''}
                                disabled={true}
                            // handleChange={(event) => props.handleChangeForWork(event, 'personName')}
                            // className={props.validState?.error?.personName !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Transporter</label>
                            <TextInput type='text'
                                id='transporter' name='transporter'
                                value={props.workObject.transporter}
                                handleChange={(event) => props.handleChangeForWork(event, 'transporter')}
                                className={props.validState?.error?.transporter !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>P.O. no</label>
                            <TextInput type='text'
                                id='poNo' name='poNo'
                                value={props.workObject.poNo}
                                handleChange={(event) => props.handleChangeForWork(event, 'poNo')}
                                className={props.validState?.error?.poNo !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>PO date</label>
                            <TextInput type='date'
                                id='poDate' name='poDate'
                                value={props.workObject.poDate}
                                handleChange={(event) => props.handleChangeForWork(event, 'poDate')}
                                className={props.validState?.error?.poDate !== undefined ? "error" : ""}
                            />
                        </div>
                    </div>
                    {props.workObject.idWOOrderRecv > 0 ?
                        <div className='btn-grp flex items-center gap-2.5 col-span-3'>
                            <button
                                className="save-btn btns py-[10px] px-[20px] " onClick={() => props.generateWoOrderInvoice()}>Download Invoice
                            </button>
                            <button
                                className="save-btn btns py-[10px] px-[20px] " onClick={() => props.generatePendingWoOrderInvoice()}>Download Pending Invoice
                            </button>

                            <button
                                className="save-btn btns py-[10px] px-[20px] " onClick={() => props.shareOnWhatsApp()}>Share On WhatsApp
                            </button>

                            <button
                                className="save-btn btns py-[10px] px-[20px] " onClick={() => props.sendOnEmail()}>Send Email
                            </button>

                        </div>
                        : null}
                </div>
                <span className="text-blue text-[16px] font-semibold">Item details</span>
                <div className='item-inner grid grid-cols-6 items-start gap-2.5 mt-2'>
                    <div className='input-grp'>
                        <label>Drawing no</label>
                        <TextInput type='text'
                            id='drawingNo' name='drawingNo'
                            value={props.itemObject.drawingNo}
                            handleChange={(event) => props.handleChange(event, 'drawingNo')}
                            className={props.validState?.error?.drawingNo !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Item category</label>
                        <MultiSelectDropdown
                            drpIdentity="Select category"
                            options={props.itemObject.itemCategoryList}
                            value={props.itemObject.idCategory ? props.itemObject.itemCategoryList.find(x => x.value === props.itemObject.idCategory) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdownForProductObject(event, "idCategory")
                            }
                            className={props.validState?.error?.idCategory !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Item name</label>
                        {/* <MultiSelectDropdown
                            drpIdentity="Select item"
                            options={props.itemObject.itemList}
                            value={props.itemObject.idItem ? props.itemObject.itemList.find(x => x.value === props.itemObject.idItem) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdownForProductObject(event, "idItem")
                            }
                            className={props.validState?.error?.idItem !== undefined ? "error" : ""}
                        /> */}
                        <TextInput
                            id="SelectItem"
                            name="SelectItem"
                            value={props.itemObject.itemIdLabel}
                            handleOnClick={(event) => props.handleOnClick(event, "itemList")}
                        // className={props.validState?.error?.chequeBookSeries !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Unit</label>
                        <TextInput type='text'
                            id='unit' name='unit'
                            value={props.itemObject.unit}
                            handleChange={(event) => props.handleChange(event, 'unit')}
                            className={props.validState?.error?.unit !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Quantity</label>
                        <TextInput type='number'
                            id='quantity' name='quantity'
                            value={props.itemObject.quantity}
                            handleChange={(event) => props.handleChange(event, 'quantity')}
                            className={props.validState?.error?.quantity !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Rate</label>
                        <TextInput type='number'
                            id='rate' name='rate'
                            value={props.itemObject.rate}
                            handleChange={(event) => props.handleChange(event, 'rate')}
                            className={props.validState?.error?.rate !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Amount</label>
                        <TextInput type='number'
                            id='amount' name='amount'
                            value={props.itemObject.amount}
                            handleChange={(event) => props.handleChange(event, 'amount')}
                            className={props.validState?.error?.amount !== undefined ? "error" : ""}
                            disabled={true}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Discount (%)</label>
                        <TextInput type='number'
                            id='discount' name='discount'
                            value={props.itemObject.discount}
                            handleChange={(event) => props.handleChange(event, 'discount')}
                            className={props.validState?.error?.discount !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Charges amount</label>
                        <TextInput type='number'
                            id='chargeAmt' name='chargeAmt'
                            value={props.itemObject.chargeAmt}
                            handleChange={(event) => props.handleChange(event, 'chargeAmt')}
                            className={props.validState?.error?.chargeAmt !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Total</label>
                        <TextInput type='number'
                            id='total' name='total'
                            value={props.itemObject.total}
                            handleChange={(event) => props.handleChange(event, 'total')}
                            className={props.validState?.error?.total !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Tax group</label>
                        <MultiSelectDropdown
                            drpIdentity="Select tax"
                            options={props.itemObject.taxList}
                            value={props.itemObject.idTaxGroup ? props.itemObject.taxList.find(x => x.value === props.itemObject.idTaxGroup) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdownForProductObject(event, "idTaxGroup")
                            }
                            className={props.validState?.error?.idTaxGroup !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>SGST {props.itemObject.sgst > 0 ? `- ${props.itemObject.sgst}%` : ""}</label>
                        <TextInput type='number'
                            id='sgstAmt' name='sgstAmt'
                            value={props.itemObject.sgstAmt}
                            handleChange={(event) => props.handleChange(event, 'sgstAmt')}
                            className={props.validState?.error?.sgstAmt !== undefined ? "error" : ""}
                            disabled={true}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>CGST {props.itemObject.cgst > 0 ? `- ${props.itemObject.cgst}%` : ""}</label>
                        <TextInput type='number'
                            id='cgstAmt' name='cgstAmt'
                            value={props.itemObject.cgstAmt}
                            handleChange={(event) => props.handleChange(event, 'cgstAmt')}
                            className={props.validState?.error?.cgstAmt !== undefined ? "error" : ""}
                            disabled={true}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>IGST {props.itemObject.igst > 0 ? `- ${props.itemObject.igst}%` : ""}</label>
                        <TextInput type='number'
                            id='igstAmt' name='igstAmt'
                            value={props.itemObject.igstAmt}
                            handleChange={(event) => props.handleChange(event, 'igstAmt')}
                            className={props.validState?.error?.igstAmt !== undefined ? "error" : ""}
                            disabled={true}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Net total</label>
                        <TextInput type='number'
                            id='netTotal' name='netTotal'
                            value={props.itemObject.netTotal}
                            handleChange={(event) => props.handleChange(event, 'netTotal')}
                            className={props.validState?.error?.netTotal !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Remarks</label>
                        <TextInput type='text'
                            id='remarks' name='remarks'
                            value={props.itemObject.remarks}
                            handleChange={(event) => props.handleChange(event, 'remarks')}
                            className={props.validState?.error?.remarks !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='btn-grp flex gap-2.5 '>
                        {props.itemObject.keyId > 0 ?
                            <>
                                {props.itemObject.isMaterialPlanningEntryExists || props.itemObject.isDeliveryChallanEntryExists ? (
                                    <>
                                        <button className="save-btn btns py-[10px] px-[20px]" disabled onClick={() => props.insert("Update")}>Update</button>
                                        <button className="delete-btn btns py-[10px] px-[20px] " disabled onClick={() => props.delete(props.itemObject.keyId)}>Delete</button>
                                    </>
                                ) :
                                    <>
                                        <button className="save-btn btns py-[10px] px-[20px]" onClick={() => props.insert("Update")}>Update</button>
                                        <button className="delete-btn btns py-[10px] px-[20px] " onClick={() => props.delete(props.itemObject.keyId)}>Delete</button>
                                    </>
                                }
                            </>
                            :
                            <button className="save-btn btns py-[10px] px-[20px]" onClick={() => props.insert("Insert")}>Insert</button>
                        }

                        <button className="edit-btn btns py-[10px] px-[20px] " onClick={() => props.clear()}>Clear</button>
                    </div>
                </div>
                <div className="process-table h-[30vh] mt-5">
                    <div className="table-inner h-full">
                        <AgGridReact
                            rowData={props.itemRowData}
                            columnDefs={itemColdefs}
                            onCellClicked={props.handleCellClickItemList}
                            onGridReady={props.onGridReady}
                            overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                            overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                        />
                    </div>
                </div>
                <div className='total-amt mt-2.5 p-2.5 bg-[#3f8cff1a] rounded-[10px]'>
                    <span className="text-blue text-[16px] font-semibold">Payment details</span>
                    <div className='input-grp-outer grid grid-cols-7 gap-2.5 mt-2.5'>
                        <div className='input-grp'>
                            <label>Total quantity</label>
                            <TextInput type='number'
                                id='totalQty' name='totalQty'
                                value={props.paymentDetails.totalQty}
                                handleChange={(event) => props.handleChange(event, 'totalQty')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Total amount</label>
                            <TextInput type='number'
                                id='totalAmt' name='totalAmt'
                                value={props.paymentDetails.totalAmt}
                                handleChange={(event) => props.handleChange(event, 'totalAmt')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Extra charges</label>
                            <TextInput type='number'
                                id='extraCharges' name='extraCharges'
                                value={props.paymentDetails.extraCharges}
                                handleChange={(event) => props.handleChange(event, 'extraCharges')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Discount amount</label>
                            <TextInput type='number'
                                id='disAmt' name='disAmt'
                                value={props.paymentDetails.disAmt}
                                handleChange={(event) => props.handleChange(event, 'disAmt')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Taxable amount</label>
                            <TextInput type='number'
                                id='taxableAmt' name='taxableAmt'
                                value={props.paymentDetails.taxableAmt}
                                handleChange={(event) => props.handleChange(event, 'taxableAmt')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Tax amount</label>
                            <TextInput type='number'
                                id='taxAmt' name='taxAmt'
                                value={props.paymentDetails.taxAmt}
                                handleChange={(event) => props.handleChange(event, 'taxAmt')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Total with tax</label>
                            <TextInput type='number'
                                id='totalWithTax' name='totalWithTax'
                                value={props.paymentDetails.totalWithTax}
                                handleChange={(event) => props.handleChange(event, 'totalWithTax')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Adjustable amount</label>
                            <TextInput type='number'
                                id='adjustableAmt' name='adjustableAmt'
                                value={props.paymentDetails.adjustableAmt}
                                handleChange={(event) => props.handleChangeForPayment(event, 'adjustableAmt')}
                                className='font-semibold'
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Final amount</label>
                            <TextInput type='number'
                                id='finalAmt' name='finalAmt'
                                value={props.paymentDetails.finalAmt}
                                handleChange={(event) => props.handleChange(event, 'finalAmt')}
                                className='font-semibold'
                                disabled
                            />
                        </div>
                    </div>
                </div>
                <div className='btn-grp flex gap-2.5 mt-5 items-center'>
                    <button className="update-btn btns" onClick={() => props.submit()} disabled={props.isChallanGenerated || props.isSaving}>Save</button>
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                    {props.isChallanGenerated ?
                        <span className="text-red-500 text-[13px]">Delivery challan already generated — this work order can no longer be edited.</span>
                        : null}
                </div>
            </div>

        </ModalBasic>
    )
}